import * as moment from 'moment'

export class DateValueConverter {
    toView(value, format) {
        format = format || 'DD/MM/YYYY';
        return !!value ? moment(value).format(format) : '';
    }
}